import * as utils from '@/utils/form.js'

export default {
  name: "nodeRight",
  props: {
    list: {
      type: Object
    },
    //指标参数
    optionSelect: {
      type: Array
    },
    //指令参数
    optionOperate: {
      type: Array
    },
    className: {
      type: String
    }
  },

  data() {
    const codeValidate = (rule, value, callback) => {
      if (this.form.trigger == 'next') {
        if (!value) {
          return callback(new Error('下一指标不能为空'));
        } else {
          callback();
        }
      }
    };
    return {
      form: {},
      pressOption: [],
      nodeItem: {
        deviationRate: '',
        standardValue: '',
        indexCode: '',
        indexName: '',
        trigger: 'filter',
      },
      rules: {
        deviationRate: [
          {required: true, message: '请输入偏差比例', trigger: 'blur'},
          {validator: utils.validate100Int, trigger: 'blur'}
        ],
        standardValue: [
          {required: true, message: '请输入标准值', trigger: 'blur'},
          // {validator: utils.validateIntOrTwoNum, trigger: 'blur'}
        ],
        indexCode: [
          {validator: codeValidate, trigger: 'change'}
        ]
      },
      // operateOption:[],
      // type:''
    }
  },
  watch: {
    list: {
      handler: function (val) {
        this.form = JSON.parse(JSON.stringify(val))
      },
      deep: true,
      immediate: true
    },
    optionSelect: {
      handler: function (val) {
        this.pressOption = val
      },
      deep: true,
      immediate: true
    },
    optionOperate: {
      handler: function (val) {
        // console.log(val)
        // if(val.length>0){
        //   this.nodeItem.trigger = val[1].dictCode
        // }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    indexCodeType: function () {
      if (this.form.indexCode && this.optionSelect.length > 0) {
        let type = this.optionSelect.find(item => {
          return item.code == this.form.indexCode
        }).type
        let result = type == '百分数' ? true : false
        return result
      } else {
        return false
      }
    }
  },
  mounted() {
    // this.type = this.$attrs.type
    // this.getOperate()
  },
  methods: {
    //获取改价单元操作
    // getOperate:function(){
    //   api.getEffectInfo({type:this.type}).then(res=>{
    //     if(res.data.code == 200){
    //       this.operateOption = res.data.data
    //       this.nodeItem.trigger = this.operateOption[1].dictCode
    //     }
    //   })
    // },
    //选择根节点指标
    nodeChangeHandle: function (value) {
      this.form.indexName = this.pressOption.find(item => {
        return item.code == value
      }).name
      this.pressOption.forEach(item => {
        // 表示子节点
        if (!item.is_root) {
          if (item.code == value) {
            this.$set(item, 'disabled', true)
            this.$set(item, 'is_right_choose', true)
            this.$set(item, 'is_children', this.className ? true : false)
          } else {
            if (item.is_left_choose) {
              this.$set(item, 'disabled', true)
              return
            }
            if (!this.className) {
              if (item.is_children && item.is_right_choose) {
                this.$set(item, 'disabled', true)
                return
              }
            } else {
              if (!item.is_children && item.is_right_choose) {
                this.$set(item, 'disabled', true)
                return
              }
            }

            this.$set(item, 'disabled', false)
            this.$set(item, 'is_right_choose', false)
          }
        }
      })
      console.log('右：', this.pressOption)
      this.$set(this.nodeItem, 'trigger', this.optionOperate[1].dictCode)
      this.$set(this.form, 'leftNode', this.nodeItem)
      this.$set(this.form, 'rightNode', this.nodeItem)
    },
    //修改触发指令
    directiveChange: function (value) {
      if (value != 'next') {
        this.pressOption = this.pressOption.map(item => {
          if (item.code == this.form.indexCode) {
            this.$set(item, 'disabled', false)
          }
          return item
        })
        this.form.indexCode = ''
        this.form.indexName = ''
        delete this.form.leftNode
        delete this.form.rightNode
      }
    },
    //输入花费
    openCostDialog: function () {
      this.$refs['costDialogDom'].handleShow(true)
    },
    costDialogHandle: function (data) {
      this.form.standardValue = data
    },
    submitNodeItem: function () {
      return new Promise((resolve, reject) => {
        const leftForm = this.$refs['nodeLeftDom'] ? this.$refs['nodeLeftDom'].$refs['nodeForm'] : this.$refs['nodeForm'];
        const rightForm = this.$refs['nodeRightDom'] ? this.$refs['nodeRightDom'].$refs['nodeForm'] : this.$refs['nodeForm'];
        // 使用Promise.all去校验结果
        Promise.all([leftForm, rightForm].map(this.getFormPromise)).then(res => {
          const validateResult = res.every(item => !!item);
          if (validateResult) {
            if (this.$refs['nodeLeftDom']) {
              this.form.leftNode = this.$refs['nodeLeftDom'].form
              this.form.rightNode = this.$refs['nodeRightDom'].form
            }
            resolve(this.form)
          } else {
            reject('两个表单未校验通过')
          }
        })
      })

    },
    getFormPromise(form) {
      return new Promise(resolve => {
        form.validate(res => {
          resolve(res);
        })
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/recommend/automaticPutin/intellPromotion/component/nodeItem/nodeRight/nodeRight.js